import { Injectable } from '@angular/core';
import { map, Observable, Subject } from 'rxjs';

// Services
import { NavigationParam, RouteParam } from '../service-base';
import { TransactionServiceBase } from './abstract/transaction-service.base';

// Modèles
import { Cheque } from 'src/app/@shared/models/banking/cheques/cheque.model';

const CLASS_NAME = 'Cheque';
const ENDPOINT = `/cheques/`;
const NAVIGATIONS: NavigationParam[] = [
    { key: 'account-entries', path: 'account-entries/', childClass: 'AccountEntryLine' },
    { key: 'potential-settlements', path: 'potential-settlements/', childClass: 'Settlement' },
    { key: 'settlements', path: 'settlements/', childClass: 'Settlement' },
]
const ROUTES: RouteParam[] = [
    { key: 'cancel', path: '{id}/cancel/' },
    { key: 'export', path: 'export/' },
    { key: 'massDelete', path: 'mass-delete/' },
    { key: 'recordOverpayment', path: '{id}/record-overpayment/' },
    { key: 'refuse', path: '{id}/refuse/' },
]

@Injectable({
    providedIn: 'root'
})
export class ChequeService extends TransactionServiceBase {

    private _refused$: Subject<Cheque> = new Subject<Cheque>();
    public readonly refused$ = this._refused$.asObservable();

    constructor() {
        super(CLASS_NAME, ENDPOINT);
        this.addNavigations(NAVIGATIONS);
        this.addRoutes(ROUTES);
    }

    public cancel$(cheque: Cheque): Observable<Cheque> {
        let url = this.routes.cancel.replace('{id}', cheque.id.toString());
        return this.update$(cheque, {
            url: url
        });
    }

    public recordOverpayment$(cheque: Cheque): Observable<Cheque> {
        return this.update$(cheque, {
            url: this.routes.recordOverpayment.replace('{id}', cheque.id.toString())
        });
    }

    public refuse$(cheque: Cheque): Observable<Cheque> {
        let url = this.routes.refuse.replace('{id}', cheque.id.toString());
        return this.update$(cheque, {
            url: url
        }).pipe(
            map(updatedCheque => {
                this._refused$.next(updatedCheque);
                return updatedCheque;
            })
        );
    }

    public refuse(cheque: Cheque): void {
        this.refuse$(cheque).subscribe(() => { });
    }
}
